export default function CFTCDisclaimer() {
  return (
    <div className="bg-yellow-900/20 border border-yellow-700/50 rounded-lg p-4 my-6">
      <p className="text-yellow-200/90 text-xs font-bold uppercase leading-relaxed tracking-wide">
        CFTC RULE 4.41 — HYPOTHETICAL OR SIMULATED PERFORMANCE RESULTS HAVE CERTAIN
        INHERENT LIMITATIONS. UNLIKE AN ACTUAL PERFORMANCE RECORD, SIMULATED RESULTS DO
        NOT REPRESENT ACTUAL TRADING. ALSO, SINCE THE TRADES HAVE NOT ACTUALLY BEEN
        EXECUTED, THE RESULTS MAY HAVE UNDER-OR-OVER COMPENSATED FOR THE IMPACT, IF ANY,
        OF CERTAIN MARKET FACTORS, SUCH AS LACK OF LIQUIDITY. SIMULATED TRADING PROGRAMS
        IN GENERAL ARE ALSO SUBJECT TO THE FACT THAT THEY ARE DESIGNED WITH THE BENEFIT OF
        HINDSIGHT. NO REPRESENTATION IS BEING MADE THAT ANY ACCOUNT WILL OR IS LIKELY TO
        ACHIEVE PROFITS OR LOSSES SIMILAR TO THOSE SHOWN.
      </p>
    </div>
  );
}
